<apt-content-box>
  <div *ngIf="page == 'payment'" fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="space-between stretch">
    <div fxFlex fxLayout="column" fxLayoutAlign="start start">
      <apt-text-label label="Insured Name">
        <apt-text-waiter [text]="insuredName"></apt-text-waiter>
      </apt-text-label>
    </div>

    <div fxFlex fxLayout="column" fxLayoutAlign="start start">
      <apt-text-label label="Address">
        <apt-text-waiter [text]="address"></apt-text-waiter>
      </apt-text-label>
    </div>

    <div fxFlex fxLayout="column" fxLayoutAlign="start start">
      <apt-text-label label="Product/Policy Type">
        <apt-text-waiter [text]="policyType"> </apt-text-waiter>
      </apt-text-label>
    </div>

    <div fxFlex fxLayout="column" fxLayoutAlign="start start">
      <apt-text-label label="Insurance Company">
        <apt-text-waiter [text]="issuingCompany"></apt-text-waiter>
      </apt-text-label>
    </div>
  </div>
  <div *ngIf="page != 'payment'" fxLayout="row">
    <div fxFlex fxLayout="column" fxLayoutAlign="start start">
      <apt-text-label label="Insured Name">
        <apt-text-waiter [text]="insuredName"></apt-text-waiter>
      </apt-text-label>
    </div>

    <div fxFlex fxLayout="column" fxLayoutAlign="start start">
      <apt-text-label label="Address">
        <apt-text-waiter [text]="address"></apt-text-waiter>
      </apt-text-label>
    </div>

    <div fxFlex fxLayout="column" fxLayoutAlign="start start">
      <apt-text-label label="Product/Policy Type">
        <apt-text-waiter [text]="policyType"> </apt-text-waiter>
      </apt-text-label>
    </div>

    <div fxFlex fxLayout="column" fxLayoutAlign="start start">
      <apt-text-label label="Insurance Company">
        <apt-text-waiter [text]="issuingCompany"></apt-text-waiter>
      </apt-text-label>
    </div>
  </div>
</apt-content-box>
